import { memo } from 'react';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { dLog } from '@/_helpers/renderDebug';
import { Props } from './types';

const PayPalPaymentButton = ({
  clientPaypalId,
  currency,
  onApprove,
  createOrder,
  onError,
}: Props) => {
  if (!clientPaypalId) return null;
  dLog('PayPalPaymentButton');
  return (
    <PayPalScriptProvider
      options={{
        clientId: clientPaypalId,
        currency,
      }}
    >
      <PayPalButtons
        style={{
          color: 'silver',
        }}
        createOrder={createOrder}
        onApprove={onApprove}
        onError={onError}
      />
    </PayPalScriptProvider>
  );
};

export default memo(PayPalPaymentButton);
